import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FiArrowUpRight, FiMenu, FiMoon, FiSun, FiX } from 'react-icons/fi';
import { useTheme } from '../contexts/ThemeContext';
import './Header.css';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const toggleRef = useRef(null);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  useEffect(() => { setOpen(false); }, [location]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    const close = (event) => {
      if (event.key === 'Escape' && open) { setOpen(false); toggleRef.current?.focus(); }
    };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [open]);
  return (
    <header className={`site-header ${location.pathname === '/' && !scrolled && !open ? 'header-over-hero' : ''}`}>
      <a className="skip-link" href="#main">Skip to content</a>
      <div className="header-inner">
        <Link to="/" className="wordmark" aria-label="Adrian Obadiah home">ao<span>.</span></Link>
        <nav id="primary-navigation" className={`primary-navigation ${open ? 'is-open' : ''}`} aria-label="Main navigation">
          <Link to="/#about">About</Link>
          <Link to="/#services">Services</Link>
          <Link to="/#projects">Work</Link>
          <NavLink to="/blog">Journal</NavLink>
          <Link to="/#contact" className="nav-contact">Let’s talk <FiArrowUpRight aria-hidden="true" /></Link>
        </nav>
        <div className="header-controls">
          <button className="icon-button theme-button" onClick={toggleTheme} aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}>{theme === 'dark' ? <FiSun /> : <FiMoon />}</button>
          <button ref={toggleRef} className="icon-button menu-toggle" onClick={() => setOpen(!open)} aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls="primary-navigation">{open ? <FiX /> : <FiMenu />}</button>
        </div>
      </div>
    </header>
  );
}
